import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import type { ExternalProviderDashboardVM } from "@shared-kernel/application/ports/external-provider/external-provider-repository";
import { useRequestDataSubmit } from "../../hooks/use-request-data-submit";
import { RequestDataSection } from "./request-data-section.content";
import {
  type RequestDataFormInputs,
  requestDataFormSchema,
  formatDashboardDataToFormData,
} from "../../form-validation/request-data-form.schema";

interface Props {
  data: ExternalProviderDashboardVM;
  onSubmitted: () => void;
}

export const RequestDataSectionContainer = ({ data, onSubmitted }: Props) => {
  const form = useForm<RequestDataFormInputs>({
    resolver: yupResolver(requestDataFormSchema),
    defaultValues: formatDashboardDataToFormData(data),
  });
  const { submitRequestData, uploadSpeakerResume, uploadAttachment, uploadProcessing } = useRequestDataSubmit(
    form,
    onSubmitted,
    data.request.id,
  );

  return (
    <RequestDataSection
      data={data}
      form={form}
      onSubmit={form.handleSubmit(submitRequestData)}
      onUploadSpeakerResume={uploadSpeakerResume}
      onUploadAttachment={uploadAttachment}
      uploadProcessing={uploadProcessing}
    />
  );
};
